import { render, staticRenderFns } from "./hotRecommend.vue?vue&type=template&id=cee0907a&scoped=true&"
import script from "./hotRecommend.vue?vue&type=script&lang=js&"
export * from "./hotRecommend.vue?vue&type=script&lang=js&"
import style0 from "./hotRecommend.vue?vue&type=style&index=0&id=cee0907a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee0907a",
  null
  
)

export default component.exports